import { render, staticRenderFns } from "./ShieldHeader.vue?vue&type=template&id=327ecc05&scoped=true&"
import script from "./ShieldHeader.vue?vue&type=script&lang=js&"
export * from "./ShieldHeader.vue?vue&type=script&lang=js&"
import style0 from "./ShieldHeader.vue?vue&type=style&index=0&id=327ecc05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327ecc05",
  null
  
)

export default component.exports